import React from "react";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import Phone from "@material-ui/icons/Phone";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  cardIconTitle: importedStyle.cardIconTitle,
  stats: importedStyle.stats,
  ...customSelectStyle
};

const BillingPackageSelect = props => {
  const { classes } = props;
  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <Phone />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Multiple Phone Packages</h4>
      </CardHeader>
      <CardBody>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="billingpackage" className={classes.selectLabel}>
            Choose package to edit
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={props.selectedBillingPackage}
            onChange={props.handleSelect}
            inputProps={{
              name: "billingpackage",
              id: "billingpackage"
            }}
          >
            {props.billingpackageList.map((element, key) => (
              <MenuItem
                key={key}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelect
                }}
                value={key}
              >
                {"   " + element}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </CardBody>
    </Card>
  );
};
export default withStyles(styles)(BillingPackageSelect);
